// extracted by mini-css-extract-plugin
export default {"imageContainer":"styles_imageContainer__yAAM5","tab":"styles_tab__7kVE6","activeTab":"styles_activeTab__KpQWt","orderFieldReadOnly":"styles_orderFieldReadOnly__78VZP"};